import { api } from '@/api'
import { BaseApi } from '@/api/BaseApi.ts'
import type {
  GroupData,
  GroupFormData,
  GroupFullData,
} from '@/api/Group/types.ts'
import type { FetchParams, Paginated, ParamType } from '@/api/types.ts'
import type { UserData } from '@/api/User/types.ts'

class Api extends BaseApi<GroupFullData, Paginated<GroupData>, GroupFormData> {
  readonly baseUrl = '/groups'

  async fetchUsers(
    id: ParamType,
    params: FetchParams
  ): Promise<Paginated<UserData>> {
    const URParams = new URLSearchParams(this.buildFetchParams(params))
    const url = `${this.baseUrl}/${id}/users?${URParams.toString()}`
    const { data } = await api.get<Paginated<UserData>>(url, this.config)
    return data
  }
}

const GroupApi = new Api()

export default GroupApi
